require('./bootstrap');

require('datatables.net-bs4');

require('./custom/main');
